export const renderConditional = (condition: boolean, content: string) =>
  condition ? content : '';
